import { render, staticRenderFns } from "./InfoStep.vue?vue&type=template&id=6e9f7a7a&scoped=true&"
import script from "./InfoStep.vue?vue&type=script&lang=js&"
export * from "./InfoStep.vue?vue&type=script&lang=js&"
import style0 from "./InfoStep.vue?vue&type=style&index=0&id=6e9f7a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f7a7a",
  null
  
)

export default component.exports